import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { persistReducer, persistStore } from 'redux-persist';

import { userSlice } from './slices/user';
import { houseRentSlice } from './slices/houseRent';
import { myselfFee } from './slices/schoolfee';
import { transportSlice } from './slices/transportLoan';
import { mychildschoolfee } from './slices/mychildSchoolfee';
import savingsReducer from './slices/savings';

// ✅ Combine your reducers
const rootReducer = combineReducers({
  user: userSlice.reducer,
  savings: savingsReducer,
  houseRent: houseRentSlice.reducer, // <-- the one we care about
  myschoolfee: myselfFee.reducer, // <-- the one we care about
  transportLoan: transportSlice.reducer, // <-- the one we care about
  mychildSchoolfee: mychildschoolfee.reducer, // <-- the one we care about
});

// ✅ Configure persistence
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'houseRent',
    'user',
    'savings',
    'myschoolfee',
    'mychildSchoolfee',
    'transportLoan',
  ], // ✅ persist only what you need
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ✅ Create the store with the persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required by Redux Persist
    }),
});

// ✅ Create the persistor
export const persistor = persistStore(store);

// ✅ Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
